// ChooseLocation.js
import React, { useEffect, useState, useRef } from "react";
import MenuHeader from "./MenuHeader";
import Modal from 'react-modal';
import useApi from "../hooks/useApi";
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { useNotifications } from '../context/NotificationProvider';
import UserService from "../services/user.service";
import ZoneService from "../services/zone.service";
import CategoryService from "../services/category.service";
import cantons from "../shared/data/cantons.json";
import { asTitle, castDate } from '../shared/utils/string';
import { Map } from "./google_map";
import axios from "../api/axios";
import Select from 'react-select';
import imageFile from "../assets/images/upload-file.svg";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Switch from "@mui/material/Switch";
import Autocomplete from 'react-google-autocomplete';
import { useLoadScript } from '@react-google-maps/api';
import EditIcon from '@mui/icons-material/Edit';
import BlockIcon from '@mui/icons-material/Block';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import GroupIcon from '@mui/icons-material/Group';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CategoryIcon from '@mui/icons-material/Category';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Menu, MenuList, MenuItem, IconButton, ListItemText, ListItemIcon, Divider, TextField, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useTranslatableData } from '../hooks/useTranslatable';
import { useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";


const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    maxHeight: "95vh",
    scrollbarWidth: "none",
  },
};

export const normalizeFlyproTagsForEdit = (tags) => {
  const existingTags = tags && typeof tags === 'object' && !Array.isArray(tags) ? tags : {};

  return {
    ...existingTags,
    bio: (typeof existingTags.bio === 'string')
      ? { fr: existingTags.bio || '', en: '' }
      : (existingTags.bio || { fr: '', en: '' }),
    experience: existingTags.experience || [],
    language: existingTags.language || [],
  };
};

const Flypro = () => {

  const navigate = useNavigate();
  const { auth } = useAuth();
  const userRoles = auth?.roles;
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [modalIsOpenManage, setIsOpenManage] = React.useState(false);
  const notify = useNotifications();
  const [showMore, setShowMore] = useState(false);

  const [customers, setCustomers] = useState([]); // État pour stocker les données des clients
  const [zones, setZones] = useState([]);
  const [managers, setManagers] = useState([]);
  const [categories, setCategories] = useState([]);

  // Use translated data for display
  const translatedCategories = useTranslatableData(categories);
  const api = useApi();
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(100);
  const [total, setTotal] = useState(0);
  const [lastPage, setLastPage] = useState(1);
  const { t } = useTranslation('flypro');
  const [formData, setFormData] = useState({
    id: null, //
    civility: null,
    firstname: "",
    lastname: "",
    phone: "",
    email: "",
    zip_code: "",
    state: "",
    state_code: "",
    street: "",
    street_number: "",
    city: "",
    zones: [],
    managers: [],
    country: "",
    country_code: "",
    role: "ROLE_FLYPRO",
    latitude: null,
    longitude: null,
    is_asca: false,
    is_rme: false,
    categories: [],
    tags: {
      bio: "",
      experience: [],
      language: [],
    },
    agent_type: null,
  });
  const [isZipCodeVisible, setIsZipCodeVisible] = useState(false);

  const fetchCategories = async () => {
    try {
      // include domain and domain.hotel so we can display hotel name for categories
      const response = await CategoryService.index(
        { parent_id: null, status: "ACTIVE", with: 'media,parent,domain,domain.hotel' },
        api
      );

      setCategories(response);
    } catch (error) {
      console.error("Error fetching parent categories:", error);
    }
  };


  // const { isLoaded, loadError } = useLoadScript({
  //   googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  //   libraries,
  // });
  const handlePhoneChange = (value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      phone: value, // Update the phone field
    }));
  };
  const isPrivileged = userRoles?.some(role => role.name === "ROLE_ADMIN");
  console.log(isPrivileged)
  const [filters, setFilters] = useState({
    with: 'primary_address,zones,managers,media,categories',
    page: currentPage,
    per_page: perPage,
    sort: 'firstname',
    ...(!isPrivileged && { ['flypro_manager_id']: auth?.user?.id })
  });
  const [filterData, setFilterData] = useState({
    search: "",
    search_by: "name",
    operator: "contains",
    status: "",
    tags: null
  });

  const [isAddressUpdate, setIsAddressUpdate] = useState(false);
  const [coordinates, setCoordinate] = useState({
    lat: 46.356,
    lng: 6.5641
  });
  const [availableZones, setAvailableZones] = useState([]);
  const [availableManagers, setAvailableManagers] = useState([]);
  const [availableCategories, setAvailableCategories] = useState([]);

  // Use translated data for display of available categories
  const translatedAvailableCategories = useTranslatableData(availableCategories);
  const timeoutRef = useRef(null);
  const [sortDirection, setSortDirection] = useState(true);
  const [showMap, setShowMap] = useState(false);

  const customSelectStyles = {
    control: (styles) => ({
      ...styles,
      width: '100%',
      height: '60px',
      padding: '0 15px',
      fontSize: '14px',
      lineHeight: '60px',
      color: '#393D44',
      border: '0',
      borderRadius: '20px',
      background: '#ffffff',
    }),
    indicatorSeparator: (base) => ({
      ...base,
      display: 'none',
    }),
    // placeholder: (base) => ({
    //   ...base,
    //   marginTop: '-10px',
    // }),
    // dropdownIndicator: (base) => ({
    //   ...base,
    //   marginTop: '-10px',
    // }),
  };

  const [selectedState, setSelectedState] = useState(null);
  const [selectedZones, setSelectedZones] = useState([]);
  const [selectedManagers, setSelectedManagers] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);

  // Use translated data for display of selected categories  
  const translatedSelectedCategories = useTranslatableData(selectedCategories);
  const [modalType, setModalType] = useState(null); // To track the type of modal
  const [selectedRow, setSelectedRow] = useState(null);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);


  /* ========================================== */

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: ['places'],
  });

  const isExpanded = (customer) => showMore === customer.id;

  const handleStateChange = (data) => {
    setIsAddressUpdate(true);
    setFormData((prev) => ({
      ...prev,
      state: data?.value,
      zip_code: ''
    }));
    setSelectedState(data);
  };

  const handleZonesChange = (selected) => {
    if (selected?.length) {
      setSelectedZones(selected);
      setFormData((prev) => ({
        ...prev,
        zones: selected.map((zone) => zone.value)
      }));
    } else {
      setSelectedZones([]);

      setFormData((prev) => ({
        ...prev,
        zones: []
      }));
    }
  };

  const handleManagersChange = (selected) => {
    if (selected?.length) {
      setSelectedManagers(selected);
      setFormData((prev) => ({
        ...prev,
        managers: selected.map((managers) => managers.value)
      }));
    } else {
      setSelectedManagers([]);

      setFormData((prev) => ({
        ...prev,
        managers: []
      }));
    }

  };

  const handleCategoriesChange = (selected) => {
    if (selected?.length) {
      setSelectedCategories(selected);
      setFormData((prev) => ({
        ...prev,
        categories: selected.map((categories) => categories.value)
      }));
    } else {
      setSelectedCategories([]);

      setFormData((prev) => ({
        ...prev,
        categories: []
      }));
    }

  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    const updatedCivility = name === 'civility' ? (formData.civility === value ? "" : value) : formData.civility;

    const updatedFormData = {
      ...formData,
      [name]: value,
      civility: updatedCivility,
    };

    if (formData.id && (name === 'zip_code' || name === 'street' || name === 'street_number' || name === 'city' || name === 'country')) {
      setIsAddressUpdate(true);
    }

    // Handle file input
    if (name === "file") {
      console.log({ e });
      const file = e.target.files[0];
      if (file) {
        setFileName(file.name);
        setFile(file);
      }
    } else {
      setFormData(updatedFormData);
    }
  };

  const handlePlaceSelect = (place) => {
    const zipCode = place.address_components.find((component) =>
      component.types.includes("postal_code")
    )?.long_name;
    const addressComponents = place.address_components;
    const updatedAddress = {
      street: '',
      city: '',
      zip_code: '',
      street_number: '',
      state: '',
      state_code: '',
      country: '',
      country_code: '',
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    };

    if (zipCode) {
      setFormData((prev) => ({ ...prev, zip_code: zipCode }));
      setIsZipCodeVisible(false);
    } else {
      setIsZipCodeVisible(true);
    }

    addressComponents.forEach(component => {
      const type = component.types[0];
      switch (type) {
        case 'street_number':
          updatedAddress.street_number = component.long_name;
          break;
        case 'route':
          updatedAddress.street = component.long_name;
          break;
        case 'locality':
          updatedAddress.city = component.long_name;
          break;
        case 'postal_code':
          updatedAddress.zip_code = component.long_name;
          break;
        case 'administrative_area_level_1':
          updatedAddress.state = component.long_name;
          updatedAddress.state_code = component.short_name;
          break;
        case 'country':
          updatedAddress.country = component.long_name;
          updatedAddress.country_code = component.short_name;
          break;
      }
    });
    setCoordinate({ lat: updatedAddress.lat, lng: updatedAddress.lng });

    setFormData((prev) => ({
      ...prev,
      street: updatedAddress.street,
      street_number: updatedAddress.street_number,
      city: updatedAddress.city,
      state: updatedAddress.state,
      state_code: updatedAddress.state_code,
      zip_code: updatedAddress.zip_code,
      country: updatedAddress.country,
      country_code: updatedAddress.country_code,
      latitude: updatedAddress.lat,
      longitude: updatedAddress.lng,
    }));
    setShowMap(false);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isAddressUpdate || (formData.zip_code !== '' && formData.latitude === null)) {
      try {
        await fetchCoordinates();
        setIsAddressUpdate(false);
      } catch (error) {
        console.error('Error fetching coordinates:', error);
      }
      notify.info('Please validate the current position');
      return;
    }

    formData.role = 'ROLE_FLYPRO';
    // Don't hardcode country - use whatever the user has set

    const formDataToSend = new FormData();

    for (const key in formData) {
      const value = formData[key];
      if (value) {
        if (Array.isArray(value) || typeof value === 'object') {
          formDataToSend.append(key, JSON.stringify(value));
        } else if (typeof value === 'boolean') {
          formDataToSend.append(key, Number(value)); // Convert boolean to string
        } else {
          formDataToSend.append(key, value);
        }
      }
    }

    if (file) {
      formDataToSend.append("imageFile", file);
    }

    try {
      const response = await (formData.id ? UserService.updateWithImage(formData.id, file ? formDataToSend : formData, file ? api : api) : UserService.store(file ? formDataToSend : formData, file ? api : api));
      if (response.data) {
        closeModal();
        fetchCustomers();
      }
    } catch (e) {
      // errors handled in interceptor
    }
  };

  const fetchCustomers = async () => {
    try {
      const response = await UserService.indexByRole(filters, 'ROLE_FLYPRO', api);
      console.log(filters);
      console.log(response.data);
      setCustomers(response.data);
      setTotal(response.total);
      setLastPage(response.last_page);
      if (response.last_page < currentPage) {
        setFilters({ ...filters, page: response.last_page })
        setCurrentPage(response.last_page);
      }
    } catch (error) {
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await UserService.delete(id, api);
      fetchCustomers();
    } catch (error) {

    }
  };

  const fetchZones = async () => {
    try {
      const response = await ZoneService.index(null, api);

      setZones(response);

    } catch (error) {
    }
  };

  const fetchManagers = async () => {
    try {
      const response = await UserService.indexByRole(null, 'ROLE_MANAGER', api);

      setManagers(response);

    } catch (error) {
    }
  };

  // Requête API pour obtenir les clients avec pagination
  useEffect(() => {
    fetchCategories();
    fetchZones();
    fetchManagers();
    fetchCustomers();
  }, [currentPage, perPage]); // Recharger les données à chaque changement de page

  function openModal(flypro) {
    if (flypro && flypro.id) {
      let phone = flypro.phone;
      if (phone && phone.startsWith("0")) {
        phone = "+41" + phone.substring(1);
      }
      const category_ids = flypro.categories?.map(category => category.id);
      setFormData({
        ...formData,
        ...flypro,
        ...{
          primary_address_id: flypro.primary_address?.id,
          zip_code: flypro.primary_address?.zip_code,
          state: flypro.primary_address?.state,
          state_code: flypro.primary_address?.state_code,
          street: flypro.primary_address?.street,
          street_number: flypro.primary_address?.street_number,
          city: flypro.primary_address?.city,
          country: flypro.primary_address?.country,
          country_code: flypro.primary_address?.country_code,
          longitude: flypro.primary_address?.longitude,
          latitude: flypro.primary_address?.latitude,
          phone,
          zones: flypro.zones.map(zone => zone.id),
          managers: flypro.managers.map(manager => manager.id),
          categories: category_ids,
          tags: normalizeFlyproTagsForEdit(flypro.tags),
          agent_type: flypro.agent_type || null,
        },
      });
      if (flypro.primary_address?.state) {
        setSelectedState({
          value: flypro.primary_address?.state,
          label: flypro.primary_address?.state
        })
      }
      if (flypro.primary_address?.longitude) {
        setCoordinate({
          lat: flypro.primary_address?.latitude,
          lng: flypro.primary_address?.longitude,
        })
      }

      setSelectedZones(
        flypro.zones?.map((zone) => ({ value: zone.id, label: zone.name })) || []
      );

      setSelectedManagers(
        flypro.managers?.map((manager) => ({
          value: manager.id,
          label: `${manager.extra.full_name} (${manager.email})`,
        })) || []
      );
      setSelectedCategories(
        translatedCategories.filter(category => category_ids.includes(category.id))?.map((category) => ({
          value: category.id,
          label: category.domain?.hotel
            ? `${category.domain?.hotel?.name} - ${category.title}`
            : category.title,
        })) || []
      );
      setFile(null);
      setFileName("");
    } else {
      resetModalStates();
    }
    setShowMap(false);
    setIsOpen(true);
  }


  function openModalManage() {
    setIsOpenManage(true);
  }

  function afterOpenModal() {

  }

  function afterOpenModalManage() {

  }

  function closeModalManage() {
    setIsOpenManage(false);
    resetModalStates();
    fetchCustomers();
  }

  function closeModal() {
    setFormData({
      id: null,
      civility: null,
      firstname: "",
      lastname: "",
      phone: "",
      email: "",
      zip_code: "",
      state: "",
      state_code: "",
      street: "",
      street_number: "",
      city: "",
      zones: [],
      managers: [],
      categories: [],
      country: "",
      country_code: "",
      role: "ROLE_FLYPRO",
      latitude: null,
      longitude: null,
      is_asca: false,
      is_rme: false,
      tags: {
        bio: "",
        experience: [],
        language: [],
      },
      agent_type: null,
    });
    setCoordinate({
      lat: 46.356,
      lng: 6.5641
    })
    setIsAddressUpdate(false);
    setIsOpen(false);
    setSelectedState(null);
  }

  const fetchCoordinates = async () => {
    const { street_number, street, city, state, zip_code, country } = formData;
    const address = `${street_number} ${street}, ${city}, ${state} ${zip_code}, ${country}`;

    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json`,
        {
          params: {
            address,
            key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
          },
        }
      );

      if (response.data.results.length > 0) {
        const location = response.data.results[0].geometry.location;
        setFormData({
          ...formData,
          latitude: location.lat,
          longitude: location.lng,
        });
        setCoordinate({
          lat: location.lat,
          lng: location.lng
        });
      } else {
        console.error('No results found for the given address.');
      }
    } catch (error) {
      console.error('Error fetching coordinates:', error);
    }
  };

  const handleCoordinateChange = (coordinates) => {
    setFormData({
      ...formData,
      longitude: coordinates[0]?.lng,
      latitude: coordinates[0]?.lat,
    })
    setCoordinate({
      lat: coordinates[0]?.lng,
      lng: coordinates[0]?.lat,
    })
  }

  function resetModalStates() {
    setFormData({
      id: null,
      civility: null,
      firstname: "",
      lastname: "",
      phone: "",
      email: "",
      zip_code: "",
      state: "",
      state_code: "",
      street: "",
      street_number: "",
      city: "",
      zones: [],
      managers: [],
      categories: [],
      country: "",
      country_code: "",
      role: "ROLE_FLYPRO",
      latitude: null,
      longitude: null,
      is_asca: false,
      is_rme: false,
      tags: {
        bio: "",
        experience: [],
        language: [],
      },
      agent_type: null,
    });
    setSelectedZones([]);
    setSelectedManagers([]);
    setSelectedCategories([]);
  }

  const fetchFilterCustomers = async () => {
    try {
      const response1 = await UserService.indexByRole(filters, 'ROLE_FLYPRO', api);
      if (filters.firstname) {
        delete filters.firstname;
        filters['lastname'] = `${filterData.operator}:${filterData.search}`;
      } else if (filters.lastname) {
        delete filters.lastname;
        filters['firstname'] = `${filterData.operator}:${filterData.search}`;
      }
      const response2 = await UserService.indexByRole(filters, 'ROLE_FLYPRO', api);
      setCustomers([...response1, ...response2]);
    } catch (error) {
      console.error("Erreur lors du chargement des clients:", error);
    }
  };

  const handleFilterSubmit = async (e) => {
    e.preventDefault();
    if (filterData.search != '') {
      filters[filterData.search_by] = `${filterData.operator}:${filterData.search}`;
    }

    if (filterData.status != '') {
      filters.status = filterData.status
    }
    await fetchCustomers();
  }

  const handleFilterChange = async (e) => {
    const target = e.target;

    if (target.name === 'search_by') {
      const search = document.querySelector('input[name="search"]');

      search.setAttribute('placeholder', `Search By ${target.options[target.selectedIndex].innerHTML}`);
      filterData.search = '';
      delete filters.name;
      delete filters.phone;
      delete filters.email;

      if (filterData.status != '') {
        filters.status = filterData.status
      }
      setFilterData({
        ...filterData,
        [target.name]: target.value
      });
      await fetchCustomers();
    } else if (target.name === 'search' && target.value === '') {
      setFilterData({
        ...filterData,
        [target.name]: target.value
      });
      delete filters.name;
      delete filters.phone;
      delete filters.email;
      if (filterData.status != '') {
        filters.status = filterData.status
      }
      await fetchCustomers();
    } else if (target.name === 'status') {
      setFilterData({
        ...filterData,
        [target.name]: target.value
      });
      if (target.value != '') {
        filters.status = target.value
      } else {
        delete filters.status;
      }
      await fetchCustomers();
    }

    setFilterData({
      ...filterData,
      [target.name]: target.value
    });
  }

  const openManageModal = async (type, row) => {
    setModalType(type);
    setSelectedRow(row);

    if (type === "zones") {
      // Separate user zones and available zones
      const userZones = zones.filter((zone) =>
        row.zones.some((userZone) => userZone.id === zone.id)
      );
      const availableZones = zones.filter(
        (zone) => !userZones.some((userZone) => userZone.id === zone.id)
      );
      setSelectedZones(userZones);
      setAvailableZones(availableZones);
    }

    if (type === "managers") {
      const userManagers = managers.filter((manager) =>
        row.managers.some((userManager) => userManager.id === manager.id)
      );
      const availableManagers = managers.filter(
        (manager) => !userManagers.some((userManager) => userManager.id === manager.id)
      );
      setSelectedManagers(userManagers);
      setAvailableManagers(availableManagers);
    }

    if (type === "categories") {
      const userCategories = translatedCategories.filter((category) =>
        row.categories.some((userCategory) => userCategory.id === category.id)
      );
      const availableCategories = translatedCategories.filter(
        (category) => !userCategories.some((userCategory) => userCategory.id === category.id)
      );
      setSelectedCategories(userCategories);
      setAvailableCategories(availableCategories);
    }


    setIsOpenManage(true);
  };

  const handleAddZone = async (zoneToAdd) => {
    // Add the zone to the user's zones
    const updatedSelectedZones = [...selectedZones, zoneToAdd];
    const updatedAvailableZones = availableZones.filter(
      (zone) => zone.id !== zoneToAdd.id
    );
    setSelectedZones(updatedSelectedZones);
    setAvailableZones(updatedAvailableZones);
  };

  const handleRemoveZone = (zoneToRemove) => {
    // Remove the zone from selectedZones
    const updatedZones = selectedZones.filter(
      (zone) => zone.id !== zoneToRemove.id
    );

    // Add the removed zone to availableZones
    const updatedAvailableZones = [...availableZones, zoneToRemove];

    setSelectedZones(updatedZones);
    setAvailableZones(updatedAvailableZones);
  };

  const handleSaveZoneChanges = async () => {
    try {
      await UserService.update(selectedRow.id, {
        zones: selectedZones.map((z) => z.id),
      }, api);

      closeModalManage();
    } catch (error) {

    }
  };

  const handleAddManager = (managerToAdd) => {
    const updatedSelectedManagers = [...selectedManagers, managerToAdd];

    const updatedAvailableManagers = availableManagers.filter(
      (manager) => manager.id !== managerToAdd.id
    );

    setSelectedManagers(updatedSelectedManagers);
    setAvailableManagers(updatedAvailableManagers);
  };

  const handleRemoveManager = (managerToRemove) => {

    const updatedManagers = selectedManagers.filter(
      (manager) => manager.id !== managerToRemove.id
    );

    const updatedAvailableManagers = [...availableManagers, managerToRemove];

    setSelectedManagers(updatedManagers);
    setAvailableManagers(updatedAvailableManagers);
  };

  const handleSearch = () => {
    if (modalType === "managers") {
      // Filter available managers based on the search query
      const availableManagers = managers.filter(
        (manager) =>
          !selectedRow.managers.some((assignedManager) => assignedManager.id === manager.id)
      );

      const filteredManagers = availableManagers.filter((manager) =>
        manager.extra.full_name.toLowerCase().includes(searchQuery.toLowerCase())
      );

      setAvailableManagers(filteredManagers);
    }

    if (modalType === "zones") {
      const availableZonesFiltered = zones.filter(
        (zone) =>
          !selectedRow.zones.some((assignedZone) => assignedZone.id === zone.id)
      );

      const filteredZones = availableZonesFiltered.filter((zone) =>
        zone.name.toLowerCase().includes(searchQuery.toLowerCase())
      );

      setAvailableZones(filteredZones);
    }

    if (modalType === "categories") {
      const availableCategoriesFiltered = translatedCategories.filter(
        (category) =>
          !selectedRow.categories.some((assignedCategory) => assignedCategory.id === category.id)
      );

      const filteredCategories = availableCategoriesFiltered.filter((category) =>
        category.title.toLowerCase().includes(searchQuery.toLowerCase())
      );

      setAvailableCategories(filteredCategories);
    }
  };

  const handleSaveManagerChanges = async () => {
    try {
      await UserService.update(selectedRow.id, {
        managers: selectedManagers.map((m) => m.id),
      }, api);

      closeModalManage();
    } catch (error) {

    }
  };

  const handleEditMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setHoveredRow(null);
    }, 250);
  };

  const handleEditMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  const handleSelectedSort = async (event) => {
    const selected = document.querySelector('.sort-header.active');
    let direction = true;
    if (selected?.id != event.target.id) {
      selected?.classList.remove('active');
      event.target.classList.add('active');
      setSortDirection(true);
    } else {
      setSortDirection(!sortDirection);
      direction = !sortDirection;
    }
    if (event.target.id != 'name') {
      setFilters({ ...filters, sort: `${direction ? '' : '-'}${event.target.id}` })
      filters.sort = `${direction ? '' : '-'}${event.target.id}`;
    } else {
      setFilters({ ...filters, sort: `${direction ? '' : '-'}firstname,${direction ? '' : '-'}lastname` })
      filters.sort = `${direction ? '' : '-'}firstname,${direction ? '' : '-'}lastname`;
    }
    await fetchCustomers();
  }

  const handleShowMap = async () => {
    if (!showMap) {
      await fetchCoordinates();
      setShowMap(true);
    } else {
      setShowMap(false);
    }
  };

  const handleNextPage = () => {
    setFilters({ ...filters, page: currentPage + 1 });
    setCurrentPage(currentPage + 1);
  }

  const handlePrevPage = () => {
    setFilters({ ...filters, page: currentPage - 1 });
    setCurrentPage(currentPage - 1);
  }

  const handleLastPage = () => {
    setFilters({ ...filters, page: lastPage });
    setCurrentPage(lastPage);
  }

  const handleFirstPage = () => {
    setFilters({ ...filters, page: 1 });
    setCurrentPage(1);
  }

  const handlePerPageChange = (e) => {
    setFilters({ ...filters, per_page: e.target.value, page: 1 });
    setPerPage(e.target.value);
    setCurrentPage(1);

  }

  const blockUser = async (user) => {
    await UserService.update(user.id, { status: 'BLOCKED' }, api);
    fetchCustomers();
  }

  const unblockUser = async (user) => {
    await UserService.update(user.id, { status: 'ACTIVE' }, api);
    fetchCustomers();
  }

  const handleAddCategory = (categoryToAdd) => {
    const updatedSelectedCategories = [...selectedCategories, categoryToAdd];
    const updatedAvailableCategories = availableCategories.filter(
      (category) => category.id !== categoryToAdd.id
    );
    setSelectedCategories(updatedSelectedCategories);
    setAvailableCategories(updatedAvailableCategories);
  };

  const handleRemoveCategory = (categoryToRemove) => {
    const updatedSelectedCategories = selectedCategories.filter(
      (category) => category.id !== categoryToRemove.id
    );
    const updatedAvailableCategories = [...availableCategories, categoryToRemove];
    setSelectedCategories(updatedSelectedCategories);
    setAvailableCategories(updatedAvailableCategories);
  };

  const handleSaveCategoryChanges = async () => {
    try {
      await UserService.update(selectedRow.id, {
        categories: selectedCategories.map((p) => p.id),
      }, api);
      closeModalManage();
    } catch (error) {

    }
  };

  const handleClick = (event, index) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedIndex(index);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedIndex(null);
  };

  const languageOptions = [
    { value: 'french', label: 'French' },
    { value: 'english', label: 'English' },
    { value: 'german', label: 'German' },
    { value: 'italian', label: 'Italian' },
    { value: 'spanish', label: 'Spanish' },
    { value: 'arabic', label: 'Arabic' },
    { value: 'portuguese', label: 'Portuguese' },
    { value: 'russian', label: 'Russian' }
  ];


  const agentTypeOptions = [
    { value: "EMPLOYEE", label: "Employee" },
    { value: "FREELANCER", label: "Freelancer" }
  ];

  const [filterMenuAnchor, setFilterMenuAnchor] = useState(null);
  const filterMenuOpen = Boolean(filterMenuAnchor);

  const handleFilterMenuClick = (event) => {
    setFilterMenuAnchor(event.currentTarget);
  };

  const handleFilterMenuClose = () => {
    setFilterMenuAnchor(null);
  };

  return (
    <>
      <MenuHeader />

      <div className="bloc-search bloc-search-mobile">
        <div className="container">
          <div className="desktop-hidden">
            <IconButton onClick={handleFilterMenuClick}>
              <img src='assets/images/filter.png' alt='actions' height={20} />
            </IconButton>
            <Menu anchorEl={filterMenuAnchor}
              open={filterMenuOpen}
              onClose={handleFilterMenuClose}
            >
              <MenuList
                style={{ padding: 0 }}
              >
                <MenuItem onClick={handleFilterMenuClose} disableRipple>
                  <ListItemIcon>
                    <img src='assets/images/filter.png' alt='actions' height={20} />

                  </ListItemIcon>
                  <ListItemText>Filters</ListItemText>
                </MenuItem>
                <Divider></Divider>
                <form onSubmit={handleFilterSubmit} className="search">
                  <div className="bloc-filtre">
                    <select
                      name="search_by"
                      value={filterData.search_by}
                      onChange={handleFilterChange}
                    >
                      <option value="name">{t('search.filters.searchBy.name')}</option>
                      <option value="email">{t('search.filters.searchBy.email')}</option>
                      <option value="phone">{t('search.filters.searchBy.phone')}</option>
                    </select>
                    <select
                      name="operator"
                      value={filterData.operator}
                      onChange={handleFilterChange}
                    >
                      <option value="contains">{t('search.filters.operator.contains')}</option>
                      <option value="starts">{t('search.filters.operator.starts')}</option>
                      <option value="ends">{t('search.filters.operator.ends')}</option>
                      <option value="eq">{t('search.filters.operator.eq')}</option>
                      <option value="!eq">{t('search.filters.operator.notEq')}</option>
                      <option value="in">{t('search.filters.operator.in')}</option>
                    </select>
                    <select
                      name="status"
                      value={filterData.status}
                      onChange={handleFilterChange}
                    >
                      <option value="">{t('search.filters.status.all')}</option>
                      <option value="ACTIVE">{t('search.filters.status.active')}</option>
                      <option value="BLOCKED">{t('search.filters.status.blocked')}</option>
                      <option value="PENDING_EMAIL_VERIFICATION">{t('search.filters.status.pendingEmail')}</option>
                      <option value="PENDING_PHONE_VERIFICATION">{t('search.filters.status.pendingPhone')}</option>
                    </select>
                  </div>
                </form>
              </MenuList>
            </Menu>
          </div>
          <div className="mobile-hidden">
            <form onSubmit={handleFilterSubmit} className="search">
              <div className="text-search">
                <input
                  type="text"
                  name="search"
                  value={filterData.search}
                  onChange={handleFilterChange}
                  placeholder={t(`search.placeholder.${filterData.search_by.toLowerCase()}`)}
                  className="form-text"
                />
                <input type="submit" className="form-submit" value={t('search.button')} />
              </div>
              <div className="bloc-filtre">
                <select
                  name="search_by"
                  value={filterData.search_by}
                  onChange={handleFilterChange}
                >
                  <option value="name">{t('search.filters.searchBy.name')}</option>
                  <option value="email">{t('search.filters.searchBy.email')}</option>
                  <option value="phone">{t('search.filters.searchBy.phone')}</option>
                </select>
                <select
                  name="operator"
                  value={filterData.operator}
                  onChange={handleFilterChange}
                >
                  <option value="contains">{t('search.filters.operator.contains')}</option>
                  <option value="starts">{t('search.filters.operator.starts')}</option>
                  <option value="ends">{t('search.filters.operator.ends')}</option>
                  <option value="eq">{t('search.filters.operator.eq')}</option>
                  <option value="!eq">{t('search.filters.operator.notEq')}</option>
                  <option value="in">{t('search.filters.operator.in')}</option>
                </select>
                <select
                  name="status"
                  value={filterData.status}
                  onChange={handleFilterChange}
                >
                  <option value="">{t('search.filters.status.all')}</option>
                  <option value="ACTIVE">{t('search.filters.status.active')}</option>
                  <option value="BLOCKED">{t('search.filters.status.blocked')}</option>
                  <option value="PENDING_EMAIL_VERIFICATION">{t('search.filters.status.pendingEmail')}</option>
                  <option value="PENDING_PHONE_VERIFICATION">{t('search.filters.status.pendingPhone')}</option>
                </select>
              </div>
            </form>
          </div>
          <button onClick={openModal} className="btn-add-client">
            {t('actions.add')}
          </button>
        </div>
      </div>

      <div className="tableau-list view-mobile view-rows">
        <div className="container">
          {customers?.length > 0 ? (
            customers.map((customer, index) => (
              <div className="list-items" key={customer.id}>
                <div className="img-items">
                  <img
                    src={`${customer.media[0]?.original_url}`}
                    alt="Flypro image"
                    style={{ width: "50px", height: "50px" }}
                  />
                </div>
                <div className="infos-items">
                  <div>{customer.id}</div>
                  <div>Firstname : {customer.firstname}</div>
                  <div>Lastname : {customer.lastname}</div>
                  <div>Phone : {customer.phone}</div>
                  <div>Email : {customer.email}</div>
                  <div>-</div>
                  <div>
                    Team : {customer?.zones?.map(
                      (zone, i) => `${zone.name}${i === customer.zones.length - 1 ? '' : ', '}`
                    )}
                  </div>
                  <div className={customer?.status?.toLowerCase()}>
                    Status : <span>{asTitle(customer.status)}</span>
                  </div>
                </div>
                <div className="menu-edit">
                  <IconButton onClick={(event) => handleClick(event, index)}>
                    <MoreVertIcon />
                  </IconButton>

                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl) && selectedIndex === index}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                  >
                    <MenuList style={{ minWidth: 180 }}>
                      <MenuItem onClick={() => { handleClose(); openModal(customer); }}>
                        <ListItemIcon>
                          <EditIcon style={{ color: "#1976d2" }} />
                        </ListItemIcon>
                        <ListItemText>Edit Flypro</ListItemText>
                      </MenuItem>
                      {customer.status !== 'BLOCKED' && (
                        <MenuItem style={{ color: 'red' }} onClick={() => { handleClose(); blockUser(customer); }}>
                          <ListItemIcon>
                            <BlockIcon style={{ color: "#FF5733" }} />
                          </ListItemIcon>
                          <ListItemText>Block Account</ListItemText>
                        </MenuItem>
                      )}
                      {customer.status !== 'ACTIVE' && (
                        <MenuItem style={{ color: 'green' }} onClick={() => { handleClose(); unblockUser(customer); }}>
                          <ListItemIcon>
                            <CheckCircleIcon style={{ color: "#28A745" }} />
                          </ListItemIcon>
                          <ListItemText>Activate Account</ListItemText>
                        </MenuItem>
                      )}
                      <MenuItem onClick={() => { handleClose(); openManageModal("zones", customer); }}>
                        <ListItemIcon>
                          <LocationOnIcon style={{ color: "#1976d2" }} />
                        </ListItemIcon>
                        <ListItemText>Manage Zones</ListItemText>
                      </MenuItem>
                      {isPrivileged && (
                      <MenuItem onClick={() => { handleClose(); openManageModal("managers", customer); }}>
                        <ListItemIcon>
                          <GroupIcon style={{ color: "#1976d2" }} />
                        </ListItemIcon>
                        <ListItemText>Manage Managers</ListItemText>
                      </MenuItem>
                      )}
                      <MenuItem onClick={() => { handleClose(); openManageModal("categories", customer); }}>
                        <ListItemIcon>
                          <CategoryIcon style={{ color: "#1976d2" }} />
                        </ListItemIcon>
                        <ListItemText>Manage Categories</ListItemText>
                      </MenuItem>
                      <MenuItem style={{ color: 'red' }} onClick={() => { handleClose(); handleDelete(customer.id); }}>
                        <ListItemIcon>
                          <DeleteIcon style={{ color: "red" }} />
                        </ListItemIcon>
                        <ListItemText>Delete</ListItemText>
                      </MenuItem>
                    </MenuList>
                  </Menu>
                </div>

              </div>
            ))
          ) : (
            <div>
              <div colSpan="8">No flypros found.</div>
            </div>
          )}
        </div>
      </div>

      <div className="tableau-list view-desktop">
        <div className="container">
          <div className="sticky-table-container">
            <table className="sticky-table">
              <thead>
                <tr>
                  <th className="sort-header" id="id" onClick={handleSelectedSort}>{t('table.headers.id')}</th>
                  <th>{t('table.headers.image')}</th>
                  <th className="sort-header" id="firstname" onClick={handleSelectedSort}>{t('table.headers.firstname')}</th>
                  <th className="sort-header" id="lastname" onClick={handleSelectedSort}>{t('table.headers.lastname')}</th>
                  <th className="sort-header" id="phone" onClick={handleSelectedSort}>{t('table.headers.phone')}</th>
                  <th className="sort-header" id="email" onClick={handleSelectedSort}>{t('table.headers.email')}</th>
                  <th>{t('table.headers.rating')}</th>
                  <th>{t('table.headers.team')}</th>
                  <th>{t('table.headers.address')}</th>
                  <th className="sort-header" id="status" onClick={handleSelectedSort}>{t('table.headers.status')}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {customers?.length > 0 ? (
                  customers.map((customer, index) => (
                    <tr
                      key={customer.id}
                      className="pointer-click"
                      onClick={() => {
                        navigate('/calendar', {
                          state: { preselectedTherapist: customer }
                        });
                      }}
                    >
                      <td>{customer.id}</td>
                      <td>
                        <img
                          src={`${customer.media[0]?.original_url}`}
                          alt="Flypro image"
                          style={{ width: "50px", height: "50px" }}
                        />
                      </td>
                      <td>{customer.firstname}</td>
                      <td>{customer.lastname}</td>
                      <td>{customer.phone}</td>
                      <td>{customer.email}</td>
                      <td className='rating-flypro-list'><img src="/assets/images/icon-stars.svg" alt='star icon' height={13.5} width={13.5} />{customer?.extra?.rating}/5</td>
                      <td>
                        {customer?.zones?.length > 3 ? (
                          <>
                            {customer.zones.slice(0, 3).map(
                              (zone, i) => `${zone.name}${i === 2 ? '' : ', '}`
                            )}

                            {isExpanded(customer) ? (
                              <>
                                {customer.zones.slice(3).map(
                                  (zone, i) =>
                                    `${zone.name}${i === customer.zones.length - 4 ? '' : ', '}`
                                )}
                                <br />
                                <button
                                  className="form-submit"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setShowMore(null);
                                  }}
                                  style={{ padding: '5px 10px', cursor: 'pointer' }}
                                >
                                  Show less
                                </button>
                              </>
                            ) : (
                              <button
                                className="form-submit"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setShowMore(customer.id);
                                }}
                                style={{ padding: '5px 10px', cursor: 'pointer' }}
                              >
                                +{customer.zones.length - 3} more
                              </button>
                            )}
                          </>
                        ) : (
                          customer?.zones?.map(
                            (zone, i) => `${zone.name}${i === customer.zones.length - 1 ? '' : ', '}`
                          )
                        )}
                      </td>
                      <td>{customer.primary_address?.street} {customer.primary_address?.street_number}, {customer.primary_address?.zip_code} {customer.primary_address?.state}, {customer.primary_address?.country}
                      </td>
                      <td className={customer?.status?.toLowerCase()}>
                        {asTitle(customer.status)}
                      </td>
                      <td onClick={(e) => e.stopPropagation()}>
                        <IconButton onClick={(event) => {
                          event.stopPropagation();
                          handleClick(event, index);
                        }}>
                          <MoreVertIcon />
                        </IconButton>

                        <Menu
                          anchorEl={anchorEl}
                          open={Boolean(anchorEl) && selectedIndex === index}
                          onClose={handleClose}
                          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                          transformOrigin={{ vertical: "top", horizontal: "right" }}
                        >
                          <MenuList style={{ minWidth: 180 }}>
                            <MenuItem onClick={(e) => {
                              e.stopPropagation(); handleClose(); openModal(customer);
                            }}>
                              <ListItemIcon>
                                <EditIcon style={{ color: "#1976d2" }} />
                              </ListItemIcon>
                              <ListItemText>{t('actions.edit')}</ListItemText>
                            </MenuItem>
                            {customer.status !== 'BLOCKED' && (
                              <MenuItem style={{ color: 'red' }} onClick={(e) => {
                                e.stopPropagation(); handleClose(); blockUser(customer);
                              }}>
                                <ListItemIcon>
                                  <BlockIcon style={{ color: "#FF5733" }} />
                                </ListItemIcon>
                                <ListItemText>{t('actions.block')}</ListItemText>
                              </MenuItem>
                            )}
                            {customer.status !== 'ACTIVE' && (
                              <MenuItem style={{ color: 'green' }} onClick={(e) => {
                                e.stopPropagation(); handleClose(); unblockUser(customer);
                              }}>
                                <ListItemIcon>
                                  <CheckCircleIcon style={{ color: "#28A745" }} />
                                </ListItemIcon>
                                <ListItemText>{t('actions.activate')}</ListItemText>
                              </MenuItem>
                            )}
                            <MenuItem onClick={(e) => {
                              e.stopPropagation(); handleClose(); openManageModal("zones", customer);
                            }}>
                              <ListItemIcon>
                                <LocationOnIcon style={{ color: "#1976d2" }} />
                              </ListItemIcon>
                              <ListItemText>{t('actions.manageZones')}</ListItemText>
                            </MenuItem>
                            {isPrivileged && (
                            <MenuItem onClick={(e) => {
                              e.stopPropagation(); handleClose(); openManageModal("managers", customer);
                            }}>
                              <ListItemIcon>
                                <GroupIcon style={{ color: "#1976d2" }} />
                              </ListItemIcon>
                              <ListItemText>{t('actions.manageManagers')}</ListItemText>
                            </MenuItem>
                            )}
                            <MenuItem onClick={(e) => {
                              e.stopPropagation(); handleClose(); openManageModal("categories", customer);
                            }}>
                              <ListItemIcon>
                                <CategoryIcon style={{ color: "#1976d2" }} />
                              </ListItemIcon>
                              <ListItemText>{t('actions.manageCategories')}</ListItemText>
                            </MenuItem>
                            <MenuItem style={{ color: 'red' }} onClick={(e) => {
                              e.stopPropagation(); handleClose(); handleDelete(customer.id);
                            }}>
                              <ListItemIcon>
                                <DeleteIcon style={{ color: "red" }} />
                              </ListItemIcon>
                              <ListItemText>{t('actions.delete')}</ListItemText>
                            </MenuItem>
                          </MenuList>
                        </Menu>
                      </td>

                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8">{t('table.noData')}</td>
                  </tr>
                )}
              </tbody>
              <tfoot >
                <tr>
                  <td colSpan={10}>
                    <div className="paginator">
                      <select value={perPage} onChange={handlePerPageChange} className="per-page">
                        <option value={1}>1</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={250}>250</option>
                        <option value={500}>500</option>
                        <option value={1000}>1000</option>
                      </select>
                      <div className="total">{t('pagination.total', { count: total })}</div>
                      <div className="pagination">
                        <button type="button" disabled={currentPage === 1} onClick={handleFirstPage}>{'<<'}</button>
                        <button type="button" disabled={currentPage === 1} onClick={handlePrevPage}>{'<'}</button>
                        <span>{currentPage} / {lastPage}</span>
                        <button type="button" disabled={currentPage === lastPage} onClick={handleNextPage}>{'>'}</button>
                        <button type="button" disabled={currentPage === lastPage} onClick={handleLastPage}>{'>>'}</button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          {/* <div className="pagination">
            <button
              onClick={handlePreviousPage}
              disabled={currentPage === 0}
              className="pagination-button"
            >
              Précédent
            </button>
            <span>
              Page {currentPage + 1} sur {totalPages}
            </span>
            <button
              onClick={handleNextPage}
              disabled={currentPage >= totalPages - 1}
              className="pagination-button"
            >
              Suivant
            </button>
          </div> */}
        </div>
      </div>

      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        ariaHideApp={false}
        contentLabel="Example Modal"
      >

        <button className="close-button" onClick={closeModal}>
          <span className="close-icon">✖</span>
        </button>

        <h2>{formData.id ? t('actions.edit') : t('modal.title')}</h2>
        <p>{t('modal.info')}</p>
        <div className="form-inscription">
          <form onSubmit={handleSubmit}>
            <div className="form-choix">
              <div className="form-radio">
                <input type="checkbox" name="civility" value="MS" id="MS" checked={formData.civility === "MS"} onChange={handleChange} />
                <label htmlFor="MS">{t('modal.form.civility.mrs')}</label>
              </div>
              <div className="form-radio">
                <input type="checkbox" name="civility" value="MR" id="MR" checked={formData.civility === "MR"} onChange={handleChange} />
                <label htmlFor="MR">{t('modal.form.civility.mr')}</label>
              </div>
            </div>
            <div className="flex-row gap-10">
              <div className="form-text">
                <label>{t('modal.form.firstname')} </label>
                <input type="text" value={formData.firstname} name="firstname" onChange={handleChange} />
              </div>

              <div className="form-text">
                <label>{t('modal.form.lastname')} </label>
                <input type="text" value={formData.lastname} name="lastname" onChange={handleChange} />
              </div>
            </div>
            <div className="form-text">
              <label>{t('modal.form.phone')} *</label>
              <PhoneInput
                defaultCountry="ch"
                type="tel"
                name="phone"
                value={formData.phone}
                disableCountryGuess={false}
                //hideDropdown="true"
                forceDialCode="true"
                //onChange={handlePhoneChange}
                onChange={(phone) => handlePhoneChange(phone)}
                required
              />
            </div>

            <div className="form-text">
              <label>{t('modal.form.email')}</label>
              <input type="email" value={formData.email} name="email" onChange={handleChange} />
            </div>

            <div className="flex-row gap-10">
              <div className="form-text">
                <label htmlFor="street">{t('modal.form.address.select')}</label>
                <Autocomplete
                  apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                  onPlaceSelected={handlePlaceSelect}
                  options={{
                    types: ["address"],
                    componentRestrictions: { country: ["CH", "FR"] },
                  }}
                  style={{
                    height: "60px",
                    padding: "0 15px",
                    border: "0",
                    borderRadius: "20px",
                    boxShadow: "0px 8px 50px 0px rgba(0, 0, 0, 0.06)",
                  }}
                  defaultValue={
                    formData.street
                      ? `${formData.street_number} ${formData.street}, ${formData.city}, ${formData.state} ${formData.zip_code}`
                      : ""
                  }
                  className={`address-input ${isZipCodeVisible ? "compact" : ""}`}
                />
              </div>

              {isZipCodeVisible && (
                <div className="form-group zip-code-input">
                  <label>{t('modal.form.address.zipCode')} *</label>
                  <input
                    type="text"
                    value={formData.zip_code}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        zip_code: e.target.value,
                      }))
                    }
                    required
                  />
                </div>
              )}

              <div className="form-group icon-top-margin">
                {formData.zip_code && (
                  <img
                    src="assets/images/map-icon.svg"
                    alt="Map Icon"
                    className="clickable"
                    onClick={handleShowMap}
                  />
                )}
              </div>
            </div>

            {formData.latitude && showMap && (<Map
              coordinates={[coordinates]}
              mode="edit"
              containerStyle={{ width: '100%', height: '400px' }}
              mapOptions={{
                disableDefaultUI: true,
                zoomControl: true,
                mapTypeControl: false,
                fullscreenControl: true,
                streetViewControl: false,
              }}
              onCoordinateChange={handleCoordinateChange}
            />)}

            <div className="form-text">
              <label>{t('modal.form.zones')}</label>
              <Select
                value={selectedZones}
                onChange={handleZonesChange}
                name="state"
                options={zones.map((zone) => ({ value: zone.id, label: zone.name }))}
                styles={customSelectStyles}
                isClearable
                isMulti
                isSearchable
                placeholder="Select a zone"
                className="basic-multi-select"
                classNamePrefix="select"
                noOptionsMessage={() => "No Zone Available"} />
            </div>

            <div className="form-select">
              <label>{t('modal.form.managers')}</label>
              <Select
                value={selectedManagers}
                onChange={handleManagersChange}
                name="state"
                options={managers.map((manager) => ({ value: manager.id, label: `${manager.extra.full_name} (${manager.email})` }))}
                styles={customSelectStyles}
                isClearable
                isMulti
                isSearchable
                placeholder="Select a Manager"
                className="basic-multi-select"
                classNamePrefix="select"
                noOptionsMessage={() => "No Manager Available"} />
            </div>

            <div className="form-text">
              <label>{t('modal.form.categories')}</label>
              <Select
                value={selectedCategories}
                onChange={handleCategoriesChange}
                name="categories"
                options={translatedCategories?.map((category) => ({
                  value: category.id,
                  label: category.domain?.hotel
                    ? `${category.domain?.hotel?.name} - ${category.title}`
                    : category.title,
                }))}
                styles={customSelectStyles}
                isClearable
                isMulti
                isSearchable
                placeholder="Select a category"
                className="basic-multi-select"
                classNamePrefix="select"
                noOptionsMessage={() => "No category Available"} />
            </div>

            {/* Bio (FR / EN) */}
            <div className="form-text">
              <label>{t('modal.form.bio')} (FR)</label>
              <textarea
                name="bio_fr"
                value={formData?.tags?.bio?.fr || ''}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    tags: { ...prev.tags, bio: { ...(prev.tags?.bio || {}), fr: e.target.value } },
                  }))
                }
                placeholder="Entrez la biographie en français"
                rows="3"
                className="formTextArea"
              ></textarea>
            </div>
            <div className="form-text">
              <label>{t('modal.form.bio')} (EN)</label>
              <textarea
                name="bio_en"
                value={formData?.tags?.bio?.en || ''}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    tags: { ...prev.tags, bio: { ...(prev.tags?.bio || {}), en: e.target.value } },
                  }))
                }
                placeholder="Enter biography in English"
                rows="3"
                className="formTextArea"
              ></textarea>
            </div>

            {/* Experience */}
            <div className="form-text">
              <label>{t('modal.form.experience')}</label>
              <div className="tags-management">
                <ul>
                  {formData.tags?.experience?.map((exp, index) => (
                    <li key={index}>
                      {exp}
                      <button
                        type="button"
                        onClick={() =>
                          setFormData((prev) => ({
                            ...prev,
                            tags: {
                              ...prev.tags,
                              experience: prev.tags.experience.filter((_, i) => i !== index),
                            },
                          }))
                        }
                      >
                        {t('manageModal.remove')}
                      </button>
                    </li>
                  ))}
                </ul>
                <input
                  type="text"
                  value={formData?.newExperience || ""}
                  onChange={(e) =>
                    setFormData((prev) => ({ ...prev, newExperience: e.target.value }))
                  }
                  placeholder={t('modal.form.experiencePlaceholder')}
                />
                <button
                  type="button"
                  onClick={() => {
                    if (formData.newExperience) {
                      setFormData((prev) => ({
                        ...prev,
                        tags: {
                          ...prev.tags,
                          experience: [...(prev.tags?.experience || []), formData.newExperience],
                        },
                        newExperience: "",
                      }));
                    }
                  }}
                >
                  {t('manageModal.add')}
                </button>
              </div>
            </div>

            {/* Language */}
            <div className="form-text">
              <label>{t('modal.form.languages')}</label>
              <div className="form-text">
                <Select
                  isMulti
                  value={formData.tags?.language?.map((lang) => ({
                    value: lang,
                    label: asTitle(lang),
                  }))}
                  onChange={(selectedOptions) =>
                    setFormData((prev) => ({
                      ...prev,
                      tags: {
                        ...prev.tags,
                        language: selectedOptions.map((option) => option.value),
                      },
                    }))
                  }
                  options={languageOptions}
                  styles={customSelectStyles}
                  placeholder={t('modal.form.selectLanguage')}
                  classNamePrefix="select"
                  noOptionsMessage={() => "No languages available"}
                />
              </div>
            </div>

            <div className="form-text">
              <label>{t('modal.form.agentType.title')} *</label>
              <Select
                value={agentTypeOptions.find((option) => option.value === formData.agent_type)}
                onChange={(selectedOption) =>
                  setFormData((prev) => ({
                    ...prev,
                    agent_type: selectedOption ? selectedOption.value : null,
                  }))
                }
                options={agentTypeOptions}
                styles={customSelectStyles}
                isClearable
                placeholder="Select Agent Type"
                noOptionsMessage={() => "No agent type available"}
                required
              />
            </div>

            <label className="fileLabel" htmlFor="file">
              {t('modal.form.image')}
            </label>
            <div className="fileField">
              <label htmlFor="file">
                <img className="imgFile" src={imageFile || ""} alt="File upload" />
                {fileName ? (
                  <div>Uploaded File: {fileName}</div>
                ) : (
                  <>
                    <div className="selectFileTo">{t('modal.form.selectFile')}</div>
                    <div className="orDragAnd">{t('modal.form.orDragAnd')}</div>
                  </>
                )}
              </label>
              <input
                type="file"
                id="file"
                name="file"
                accept="image/*"
                onChange={handleChange}
                ref={fileInputRef}
                style={{ display: "none" }}
              />
            </div>
            <div className="capability-input topMargArea">
              <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
                <Typography>ASCA</Typography>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Typography>{t('modal.form.certifications.no')}</Typography>
                  <Switch
                    checked={formData.is_asca}
                    onChange={(e) => {
                      setFormData({ ...formData, is_asca: e.target.checked ? true : false })
                    }}
                    inputProps={{ 'aria-label': 'ASCA' }}
                  />
                  <Typography>{t('modal.form.certifications.yes')}</Typography>
                </Stack>
              </Stack>
            </div>

            <div className="capability-input topMargArea">
              <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
                <Typography>RME</Typography>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Typography>{t('modal.form.certifications.no')}</Typography>
                  <Switch
                    checked={formData.is_rme}
                    onChange={(e) => {
                      setFormData({ ...formData, is_rme: e.target.checked ? true : false })
                    }}
                    inputProps={{ 'aria-label': 'RME' }}
                  />
                  <Typography>{t('modal.form.certifications.yes')}</Typography>
                </Stack>
              </Stack>
            </div>
            <button type="submit" className="btn-submit">
              {formData.id ? t('manageModal.save') : t('actions.add')}
            </button>
          </form>
        </div>
      </Modal>

      <Modal
        isOpen={modalIsOpenManage}
        onAfterOpen={afterOpenModalManage}
        onRequestClose={closeModalManage}
        style={customStyles}
        ariaHideApp={false}
        contentLabel="Manage Modal"
      >
        <div className="bloc-manage">
          {modalType === "zones" && (
            <div className="manage-zones-modal">
              <h2>{t('manageModal.zones.title')} {selectedRow?.firstname} {selectedRow?.lastname}</h2>
              {/* Assigned Zones Section  */}
              <div className="currently-managed">
                <h3>{t('manageModal.zones.assigned')}</h3>
                <div className="tableau-list no-scroll">
                  <div className="container">
                    <table>
                      {selectedZones.length === 0 ? (
                        <tbody>
                          <tr>
                            <td colSpan="4">
                              <div className="empty-cell" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '18px 8px', color: '#6b7280' }}>
                                <div style={{ marginTop: 8, fontWeight: 600 }}>{t('manageModal.zones.empty')}</div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        selectedZones.map((zone, index) => (
                          <thead key={index} className="no-background">
                            <tr>
                              <th>{zone.id}</th>
                              <th>{selectedRow?.firstname} {selectedRow?.lastname}</th>
                              <th>{zone.name}</th>
                              <th>
                                <button
                                  className="form-submit"
                                  onClick={() => handleRemoveZone(zone)}
                                >
                                  {t('manageModal.zones.noAssigned')}
                                </button>
                              </th>
                            </tr>
                          </thead>
                        ))
                      )}
                    </table>
                  </div>
                </div>
              </div>

              {/* Available Zones Section */}
              <div className="available-zones">
                <h3>{t('manageModal.zones.available')}</h3>
                <div className="bloc-search no-background">
                  <div className="container search-center">
                    <div className="search">
                      <div className="text-search">
                        <input
                          type="text"
                          name="search"
                          placeholder={t('manageModal.zones.search')}
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          className="form-text"
                        />
                        <input type="submit" onClick={handleSearch} className="form-submit" value={t('manageModal.search')} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tableau-list no-scroll">
                  <div className="container">
                    <table>
                      {availableZones.length === 0 ? (
                        <tbody>
                          <tr>
                            <td colSpan="3">
                              <div className="empty-cell" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '18px 8px', color: '#6b7280' }}>
                                <div style={{ marginTop: 8, fontWeight: 600 }}>{t('manageModal.zones.empty')}</div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        availableZones.map((zone, index) => (
                          <thead key={index} className="no-background">
                            <tr>
                              <th>{zone.id}</th>
                              <th>{zone.name}</th>
                              <th>
                                <button
                                  className="form-submit"
                                  onClick={() => handleAddZone(zone)}
                                >
                                  {t('manageModal.add')}
                                </button>
                              </th>
                            </tr>
                          </thead>
                        ))
                      )}
                    </table>
                  </div>
                </div>
              </div>

              {/* Save Changes Button */}
              <button className="save-submit" onClick={handleSaveZoneChanges}>
                {t('manageModal.save')}
              </button>
            </div>
          )}

          {modalType === "managers" && (
            <div className="manage-managers-modal">
              <h2>{t('manageModal.managers.title')} {selectedRow?.firstname} {selectedRow?.lastname}</h2>
              {/* Assigned Managers Section */}
              <div className="currently-managed">
                <h3>{t('manageModal.managers.assigned')}</h3>
                <div className="tableau-list no-scroll">
                  <div className="container">
                    <table>
                      {selectedManagers.length === 0 ? (
                        <tbody>
                          <tr>
                            <td colSpan="3">
                              <div className="empty-cell" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '18px 8px', color: '#6b7280' }}>
                                <div style={{ marginTop: 8, fontWeight: 600 }}>{t('manageModal.managers.empty')}</div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        selectedManagers.map((manager, index) => (
                          <thead key={index} className="no-background">
                            <tr>
                              <th>{manager.id}</th>
                              <th>{manager?.extra?.full_name}</th>
                              <th>
                                <button
                                  className="form-submit"
                                  onClick={() => handleRemoveManager(manager)}
                                >
                                  {t('manageModal.remove')}
                                </button>
                              </th>
                            </tr>
                          </thead>
                        ))
                      )}
                    </table>
                  </div>
                </div>
              </div>

              {/* Available Managers Section */}
              <div className="available-managers">
                <h3>{t('manageModal.managers.available')}</h3>
                <div className="bloc-search no-background">
                  <div className="container search-center">
                    <div className="search">
                      <div className="text-search">
                        <input
                          type="text"
                          name="search"
                          placeholder={t('manageModal.managers.search')}
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          className="form-text"
                        />
                        <input type="submit" onClick={handleSearch} className="form-submit" value={t('manageModal.search')} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tableau-list no-scroll">
                  <div className="container">
                    <table>
                      {availableManagers.length === 0 ? (
                        <tbody>
                          <tr>
                            <td colSpan="7">
                              <div className="empty-cell" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '18px 8px', color: '#6b7280' }}>
                                <div style={{ marginTop: 8, fontWeight: 600 }}>{t('manageModal.managers.empty')}</div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        availableManagers.map((manager, index) => (
                          <thead key={index} className="no-background">
                            <tr>
                              <th>{manager.id}</th>
                              <th colSpan="3">{manager.extra.full_name}</th>
                              <th>{manager.email}</th>
                              <th></th>
                              <th>
                                <button
                                  className="form-submit"
                                  onClick={() => handleAddManager(manager)}
                                >
                                  {t('manageModal.add')}
                                </button>
                              </th>
                            </tr>
                          </thead>
                        ))
                      )}
                    </table>
                  </div>
                </div>
              </div>

              {/* Save Changes Button */}
              <button className="save-submit" onClick={handleSaveManagerChanges}>
                {t('manageModal.save')}
              </button>
            </div>
          )}

          {modalType === "categories" && (
            <div className="manage-managers-modal">
              <h2>{t('manageModal.categories.title')} {selectedRow?.firstname} {selectedRow?.lastname}</h2>
              {/* Assigned Categories Section */}
              <div className="currently-managed">
                <h3>{t('manageModal.categories.assigned')}</h3>
                <div className="tableau-list no-scroll">
                  <div className="container">
                    <table>
                      {translatedSelectedCategories.length === 0 ? (
                        <tbody>
                          <tr>
                            <td colSpan="3">
                              <div className="empty-cell" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '18px 8px', color: '#6b7280' }}>
                                <div style={{ marginTop: 8, fontWeight: 600 }}>{t('manageModal.categories.empty')}</div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        translatedSelectedCategories.map((category, index) => (
                          <thead key={index} className="no-background">
                            <tr>
                              <th>{category.id}</th>
                              <th>
                                {category.title}
                                {((category.domain && category.domain.hotel && category.domain.hotel.name) || (category.hotel && category.hotel.name)) ? ` - ${((category.domain && category.domain.hotel && category.domain.hotel.name) || (category.hotel && category.hotel.name))}` : ''}
                              </th>
                              <th>
                                <button
                                  className="form-submit"
                                  onClick={() => handleRemoveCategory(category)}
                                >
                                  {t('manageModal.remove')}
                                </button>
                              </th>
                            </tr>
                          </thead>
                        ))
                      )}
                    </table>
                  </div>
                </div>
              </div>

              {/* Available Categories Section */}
              <div className="available-managers">
                <h3>{t('manageModal.categories.available')}</h3>
                <div className="bloc-search no-background">
                  <div className="container search-center">
                    <div className="search">
                      <div className="text-search">
                        <input
                          type="text"
                          name="search"
                          placeholder={t('manageModal.categories.search')}
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          className="form-text"
                        />
                        <input type="submit" onClick={handleSearch} className="form-submit" value={t('manageModal.search')} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tableau-list no-scroll">
                  <div className="container">
                    <table>
                      {translatedAvailableCategories.length === 0 ? (
                        <tbody>
                          <tr>
                            <td colSpan="3">
                              <div className="empty-cell" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '18px 8px', color: '#6b7280' }}>
                                <div style={{ marginTop: 8, fontWeight: 600 }}>{t('manageModal.categories.empty')}</div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        translatedAvailableCategories.map((category, index) => (
                          <thead key={index} className="no-background">
                            <tr>
                              <th>{category.id}</th>
                              <th>
                                {category.title}
                                {((category.domain && category.domain.hotel && category.domain.hotel.name) || (category.hotel && category.hotel.name)) ? ` - ${((category.domain && category.domain.hotel && category.domain.hotel.name) || (category.hotel && category.hotel.name))}` : ''}
                              </th>
                              <th>
                                <button
                                  className="form-submit"
                                  onClick={() => handleAddCategory(category)}
                                >
                                  {t('manageModal.add')}
                                </button>
                              </th>
                            </tr>
                          </thead>
                        ))
                      )}
                    </table>
                  </div>
                </div>
              </div>

              {/* Save Changes Button */}
              <button className="save-submit" onClick={handleSaveCategoryChanges}>
                {t('manageModal.save')}
              </button>
            </div>
          )}

        </div>
      </Modal>
    </>
  );
};

export default Flypro;
